import { useMasterDataStore, selectAppSettings } from '@store/master-data.store';
import type { AppSettingsItem } from '@models/master-data/master-data.model';
import { resolveAppSettingsForHost } from '@utils/app-settings-resolver.util';

const DEFAULT_SKYWARDS_MEMBERSHIP_NUMBER_MIN_LENGTH = 9;

interface SkywardsSettings {
  homepageUrl: string;
  skywardsBenefits: string;
  skywardsEarning: string;
  skywardsSpending: string;
  skywardsMembershipTiers: string;
  skywardsPartners: string;
  skywardsFaq: string;
  skywardsContact: string;
  skywardsTerms: string;
  skywardsMembershipNumberMinLength: number;
}

type AppSettingsWithSkywards = AppSettingsItem &
  Partial<Omit<SkywardsSettings, 'skywardsMembershipNumberMinLength'>> & {
    skywardsMembershipNumberMinLength?: string;
  };

const resolveSkywardsMembershipNumberMinLength = (rawValue?: string): number => {
  const parsed = Number.parseInt(rawValue ?? '', 10);
  return Number.isFinite(parsed) && parsed > 0
    ? parsed
    : DEFAULT_SKYWARDS_MEMBERSHIP_NUMBER_MIN_LENGTH;
};

export function useSkywardsSettings(): SkywardsSettings {
  const appSettings = useMasterDataStore(selectAppSettings);
  const content = resolveAppSettingsForHost(appSettings) as AppSettingsWithSkywards;

  return {
    homepageUrl: content.homepageUrl ?? '',
    skywardsBenefits: content.skywardsBenefits ?? '',
    skywardsEarning: content.skywardsEarning ?? '',
    skywardsSpending: content.skywardsSpending ?? '',
    skywardsMembershipTiers: content.skywardsMembershipTiers ?? '',
    skywardsPartners: content.skywardsPartners ?? '',
    skywardsFaq: content.skywardsFaq ?? '',
    skywardsContact: content.skywardsContact ?? '',
    skywardsTerms: content.skywardsTerms ?? '',
    skywardsMembershipNumberMinLength: resolveSkywardsMembershipNumberMinLength(
      content.skywardsMembershipNumberMinLength,
    ),
  };
}
